/**
 * Sorts an array of strings by the number after the underscore
 * Example: ['device_10', 'device_2', 'device_1'] becomes ['device_1', 'device_2', 'device_10']
 *
 * @param strings Array of strings to sort
 * @returns Sorted array of strings
 */
export const sortByUnderscoreNumber = (strings: string[]): string[] => {
  return strings.slice().sort((a, b) => {
    // Extract number after underscore
    const getNumberAfterUnderscore = (str: string): number => {
      const parts = str.split('_');

      if (parts.length < 2) {
        return 0;
      }

      const numberStr = parts[parts.length - 1];
      const number = parseInt(numberStr, 10);

      return isNaN(number) ? 0 : number;
    };

    const numA = getNumberAfterUnderscore(a);
    const numB = getNumberAfterUnderscore(b);

    return numA - numB;
  });
};

export default sortByUnderscoreNumber;
